import { PaApi, baseOpts, processSuccess } from '@/services/PaApi'

export const PurchaseModule = {
  namespaced: true,

  state: {
    payment: {},
    payments: [],
    purchase: {}
  },

  getters: {
  },

  actions: {
    async resetSentAt ({ commit, state }, purchaseId) {
      commit('setLoading', true, { root: true })

      await PaApi().get(
        '/admin/purchases/' + purchaseId + '/reset_sent_at'
      ).then((resp) => {
        commit('payments', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async getPurchase ({ commit, state }, id) {
      commit('setLoading', true, { root: true })

      await PaApi().get(
        `/admin/purchases/${id}`
      ).then((resp) => {
        commit('storePurchase', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async deletePurchase ({ commit, state }, id) {
      commit('setLoading', true, { root: true })

      await PaApi().delete(
        `/admin/purchases/${id}`
      ).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async paymentLookup ({ commit, state }, query) {
      commit('setLoading', true, { root: true })

      await PaApi().post(
        '/admin/purchases/search/lookup_payment', {
          purchase: {
            external_payment_id: query
          }
        }
      ).then((resp) => {
        commit('storePurchase', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async refreshPurchase ({ commit, state }, id) {
      commit('setLoading', true, { root: true })

      await PaApi().put(
        `/admin/purchases/${id}/refresh`
      ).then((resp) => {
        commit('storePurchase', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async createPurchaseByPayment ({ commit, state }, payment) {
      commit('setLoading', true, { root: true })

      await PaApi().post(
        `/admin/purchases`, {
          purchase: payment
        }
      ).then((resp) => {
        commit('storePurchase', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async refreshPurchasableItems ({ commit, state }, id) {
      commit('setLoading', true, { root: true })

      await PaApi().put(
        `/admin/purchases/${id}/update_items`
      ).then((resp) => {
        commit('storePurchase', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    }
  },

  mutations: {
    storePayment (state, payload) {
      state.payment = payload
    },

    storePayments (state, payload) {
      state.payments = payload
    },

    storePurchase (state, payload) {
      baseOpts.merge_attrs = true

      state.purchase = processSuccess(payload, baseOpts)
    },

    storePurchases (state, payload) {
      baseOpts.merge_attrs = true

      state.purchases = processSuccess(payload, baseOpts)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/PurchaseModule.js